import { InjectionToken } from "@angular/core";

export interface TaskModalSettings {
  title: string;
  saveLabel: string;
}

export interface TaskConfig {
  add: TaskModalSettings;
  edit: TaskModalSettings;
}

export const TASK_CONFIG = new InjectionToken<TaskConfig>('task-config');